import Form from "./form";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentSchedule } from "../../../../../../../../../../../@types/attendance-local-department-schedule";
import { useAttendanceLocalDepartmentScheduleCreate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/schedule/create";

type FormCreateProps = {
    existingSchedules: AttendanceLocalDepartmentSchedule[];
    departmentId: AttendanceLocalDepartment["id"];
    buttonTrigger?: React.ReactNode;
};

export default function FormCreate(props: FormCreateProps) {
    const mutation = useAttendanceLocalDepartmentScheduleCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
